import { WidgetConfigServer } from 'widget/entities/config';
import type { MessageAttachment } from 'widget/types/attachments';

export type {
  BaseAttachment,
  MediaAttachment,
  DocumentAttachment,
  MessageAttachment
} from 'widget/types/attachments';

export enum MessageKind {
  USER = 'user',
  BOT = 'bot'
}

export interface OpenSessionResponse {
  data: {
    session_token: string;
  };
}

export interface ObtainWsTokenResponse {
  data: {
    auth_token: string;
  };
}

export interface ObtainSubscriptionTokenResponse {
  data: {
    subscription_channel: string;
    subscription_token: string;
  };
}

export interface MessageHistoryItem {
  id: string | null;
  text: string;
  kind: MessageKind;
  date_created: string;
  attachments?: MessageAttachment[];
  extra?: Record<string, unknown>;
}

export interface GetMessagesHistoryResponse {
  data: {
    messages: MessageHistoryItem[];
  };
}

export interface SendMessageResponse {
  data: {
    _id: string;
  };
}

export interface WidgetConfigResponse {
  data: WidgetConfigServer;
}

export interface WidgetConsentsData {
  personal_data?: boolean;
  mailing?: boolean;
}

export interface WidgetConsentsResponse {
  data: WidgetConsentsData;
}

export interface WidgetContactsData {
  phone?: string;
  email?: string;
  name?: string;
}

export interface WidgetContactsResponse {
  data: WidgetContactsData;
}

export interface UploadAttachmentResponse {
  data: {
    _id: string;
    filename: string;
    type: string;
    extension: string;
    size: number;
    url: string;
    preview_url?: string;
    width?: number;
    height?: number;
  };
}

export type SubmitConsentsRequest = WidgetConsentsData;
export type SubmitConsentsResponse = WidgetConsentsResponse;
export type SubmitContactsRequest = WidgetContactsData;
export type SubmitContactsResponse = WidgetContactsResponse;
